import {
  Alert,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
} from "@mui/material";
import Slide from "@mui/material/Slide";

import { useDisclosure } from "hooks";

interface Props {
  value: QuoteSortType;
  onChange: (value: QuoteSortType) => void;
  // Only offered when at least one quote has an overall verdict.
  showCompetitivenessSort: boolean;
}

export function QuoteSortDropdown(props: Props) {
  const {
    value,
    onChange: OnMenuOptionSelected,
    showCompetitivenessSort,
  } = props;

  const { isOpen, onClose, onOpen } = useDisclosure(false);

  const onChange = (selection: QuoteSortType) => {
    onOpen();
    OnMenuOptionSelected(selection);
  };

  return (
    <>
      <FormControl sx={{ minWidth: 150 }} size="small">
        <InputLabel>Sort</InputLabel>
        <Select
          value={value}
          label="Sort"
          size="small"
          onChange={(e) => onChange(e.target.value as QuoteSortType)}
        >
          <MenuItem value="ALL">All</MenuItem>
          {showCompetitivenessSort && (
            <MenuItem value="MOST_COMPETITIVE">Most competitive</MenuItem>
          )}
          {showCompetitivenessSort && (
            <MenuItem value="LEAST_COMPETITIVE">Least competitive</MenuItem>
          )}
          <MenuItem value="LATEST">Newest</MenuItem>
          <MenuItem value="OLDEST">Oldest</MenuItem>
          <MenuItem value="LOWEST_AMOUNT">Lowest Price</MenuItem>
          <MenuItem value="HIGHEST_AMOUNT">Highest Price</MenuItem>
        </Select>
      </FormControl>

      <Snackbar
        id={value}
        open={isOpen}
        autoHideDuration={1000}
        onClose={onClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        TransitionComponent={Slide}
      >
        <Alert onClose={onClose} severity="success" sx={{ width: "100%" }}>
          Sorting Criteria Applied!
        </Alert>
      </Snackbar>
    </>
  );
}
